module.exports = __webpack_public_path__ + "school/img/hanxue.7853363d.jpg";